import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import CreateShowComponent from '../../../Components/ShowComponent/CreateShowComponent';

const CreateShow = (props) => {
    let navigate = useNavigate();
    const params = useParams();

    return (
        <div>
            <CreateShowComponent {...props} navigate={navigate} id={params.id} />
        </div>
    );
}

export default CreateShow